<template>
    <div class="day-grid-week" ref="container">
        <div class="header-days">
            <div class="day" v-for="(day, index) in dayLabels" :key="day">
                <label class="day-label">{{ day }} {{ dayNumberStart + index}}</label>
                <div class="count-event" :class="{'no-content': !countEvent[index]}">{{countEvent[index]}}</div>
            </div>
        </div>
        <div class="grid">
            <div class="scrollable-area">
                <div 
                    v-for="(dayNumber, dayIndex) in 7" 
                    class="cell-day" 
                    :key="dayNumber" 
                    :class="{'today': indexToday === dayIndex}"
                >
                 
           
                    <Event 
                        v-for="event in eventsByDay[dayIndex]"
                        :key="event.id"
                        v-bind="event"
                        :isDraggable="false"
                        @eventClick="$emit('eventClick', event.id)"
                    />
            
              
                </div>
            </div>
        </div>
        <di class="btn-stacked-mode btn-radius" @click="$emit('changeView', 'timeGridWeek')">
            <i class="fa-solid fa-angles-down"></i>
            {{ $t('dash.posts.planner.expand') }}
        </di>
    </div>
</template>

<script>
    import Event from '../Event.vue'
    import DraggableEvent from '../DraggableEvent.vue';
    import EventsPopUp from '../EventsPopUp.vue';

    export default {
        components: {
            Event,
            DraggableEvent,
            EventsPopUp
        },
        props: {
            currentDate: {
                type: String,
                default: ()=> new Date().toISOString()
            },
            events: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                countEvent: Array.from({ length: 7 }, () => 0)
            }
        },
        methods: {

          


            //api
            prev() {
                const now = this.getCurrentStart();
                now.setDate(now.getDate() - 7);
                this.$emit('gotoDate', now.toISOString());
            },

            next() {    
                const now = this.getCurrentEnd();
                this.$emit('gotoDate', now.toISOString());
            },
            getCurrentStart() {
                const date = new Date(this.currentDate);
                const dayIndex = date.getDay(); // 0 = dimanche, 1 = lundi, ..., 6 = samedi
                const diff = dayIndex === 0 ? -6 : 1 - dayIndex; 
                date.setDate(date.getDate() + diff);
                date.setHours(0, 0, 0, 0); // Réinitialiser à minuit
                return date;
            },

            getCurrentEnd() {
                const date = this.getCurrentStart();
                date.setDate(date.getDate() + 7);
                return date
            },
        },
        computed: {
            dayLabels() {
                const locale = this.$i18n.locale || 'fr-FR';
                const monday = new Date(2024, 0, 1);
                return Array.from({ length: 7 }, (_, i) => {
                    const d = new Date(monday);
                    d.setDate(monday.getDate() + i);
                    return new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(d);
                });
            },
            eventsByDay() {
                //create empty 7x24 array
                const tab = Array.from({ length: 7 }, () =>  []); 
                const countEvent = Array.from({ length: 7 }, () => 0);

                const startWeekTime = this.getCurrentStart().getTime();
                const endWeekTime = this.getCurrentEnd().getTime();

                this.events.forEach(event => {
                    event.dateInstance = new Date(event.date);
                    const timestamp = event.dateInstance.getTime();

                    if (timestamp >= startWeekTime && timestamp < endWeekTime) {
                        let dayIndex = event.dateInstance.getDay();
                        dayIndex = dayIndex === 0 ? 6 : dayIndex - 1; // ajuster pour que lundi = 0
                        tab[dayIndex].push(event);
                        countEvent[dayIndex]++;
                    }
                });
                this.countEvent = countEvent;

                return tab;
                
            },
                   
            indexToday() {

                const timestamp = Date.now();

                const startWeekTime = this.getCurrentStart().getTime();
                const endWeekTime = this.getCurrentEnd().getTime();

                if (timestamp > startWeekTime && timestamp < endWeekTime) {
                    const currentDate = new Date(timestamp);
                    let dayIndex = currentDate.getDay();
                    dayIndex = dayIndex === 0 ? 6 : dayIndex - 1;
                    return dayIndex;
                }

                return -1;
              
            },

            dayNumberStart() {
                const date = this.getCurrentStart();
                return date.getDate()
            }
        },

        destroyed () {
        },
    }
</script>

